import React, { FC, useEffect, useState } from "react";
import { Col, Row, Spin } from "antd";
// import RegularGap from "./regular-gaps";
import StarGap from "./star-gaps";
// import HedisGaps from "./hedis-gaps";
// import UnderCodingMedication from "./under-coding-medication";
// import GapMedication from "./gaps-medication";
import Recommendation from "./recommendations";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { useNavigate } from "react-router-dom";
import { routeMap } from "@utils/constants";
import AlternativeGenericMedication from "./alternative-generic-medication/alternative-generic-medication";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
// import { useGlobalInformationStore } from "@stores/global_informationStore";
import Icon from "@assets/icon_config";

const ActionableInsights: FC<any> = (props) => {
  const [actionableInsightData, setActionableInsightData] = useState<any>({});
  const [loadingForActionable, setActionableLoaderFlag] = useState(false);
  const [alternativegenericmedicationData, setAlternativegenericmedicationData] = useState<any>();
  const navigate = useNavigate();

  const defaultExpandedCards = ["28"];
  const expandAllCards = ["28", "4", "35"];
  const patientId = membersService?.getCurrentMember?.patient_id;
  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);

  const getActionableInsightRecords = (id: number) => {
    setActionableLoaderFlag(true);
    memberDetailsService.getActionableInsightRecords(id).subscribe({
      next: (v: any) => {
        setActionableLoaderFlag(false);
        setActionableInsightData(v.data.data.actionableInsightData);
      },
      error: (e) => {
        console.log(e);
        setActionableLoaderFlag(false);
        setActionableInsightData({});
      },
    });
  };

  useEffect(() => {
    console.log("ActionableInsights.useEffect");
    setActivePanels(defaultExpandedCards);
    if (patientId) {
      getActionableInsightRecords(patientId);
      memberDetailsService.getAlternateMedication(patientId).subscribe({
        next: (v: any) => {
          setAlternativegenericmedicationData(v.data.data.medications);
        },
        error: (e) => {},
      });
    } else navigate(routeMap["members"]);
  }, [patientId, navigate]);

  const changeCollapse = () => {
    if (activePanels?.length > 0) {
      setActivePanels([]);
    } else {
      setActivePanels(expandAllCards);
    }
  };

  return (
    // <Spin spinning={loadingForActionable} indicator={<HealthemSpinner size={70}/>}>
    <>
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"} </span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>
      <div>
        {/*
      <Row style={{ margin: "10px 0px" }}>
        <Col span={12}>
          <Card>
            <UnderCodingMedication data={actionableInsightData?.underCodingMedication} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds}/>
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <GapMedication data={actionableInsightData?.gapsInMedication} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds}/>
          </Card>
        </Col>
      </Row> */}
        <Row>
          <Col span={24}>
            <StarGap
              data={actionableInsightData?.regularGaps}
              pinChangeHandler={props.pinChangeHandler}
              pinCardIds={props.pinCardIds}
              activeKey={activePanels}
              setActivePanels={setActivePanels}
              loading={loadingForActionable}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Recommendation
              data={actionableInsightData?.recommendations}
              pinChangeHandler={props.pinChangeHandler}
              pinCardIds={props.pinCardIds}
              getActionableInsightRecords={getActionableInsightRecords}
              activeKey={activePanels}
              setActivePanels={setActivePanels}
              loading={loadingForActionable}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AlternativeGenericMedication
              data={alternativegenericmedicationData?.values}
              loadingForActionable={loadingForActionable}
              activeKey={activePanels}
              setActivePanels={setActivePanels}
              setActiveTabKey={props.setActiveTabKey}
              pinChangeHandler={props.pinChangeHandler}
              pinCardIds={props.pinCardIds}
              alternativegenericmedicationDataPinCardID={alternativegenericmedicationData?.datacardId}
            />
          </Col>
        </Row>
        {/* <Row>
        <Col span={12}>
          <Card>
            <RegularGap data={actionableInsightData?.regularGaps} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds}/>
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <HedisGaps data={actionableInsightData?.hedisGap} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds}/>
          </Card>
        </Col>
      </Row> */}
      </div>
    </>
    // </Spin>
  );
};

export default ActionableInsights;
